import {
  FormikCheckbox,
  FormikSpinButton,
  FormikTextField,
} from 'formik-office-ui-fabric-react'
import { Box } from 'grid'
import { MaterialInsertType, MaterialSetType } from 'model'
import { Label } from 'office-ui-fabric-react'
import { Position } from 'office-ui-fabric-react/lib/utilities/positioning'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'
import { FieldStack, FieldStackItem, FormStack } from '../FormStack'

export type MaterialFormValues = MaterialInsertType | MaterialSetType
export class MaterialFormSchema {
  constructor() {
    return Yup.object().shape({
      label: Yup.string().required().trim(),
      nettoWeight: Yup.string()
        .trim()
        .matches(/^\d+(,\d*)?$/, {
          message: 'Nettogewicht muss eine Zahl sein z.B.: 1000,00 oder 1000',
        }),
      // ^\d{1,3}(?:\.\d{3})*(?:,\d+)?$ falls die Punkte haben wollen
    })
  }
}

export const MaterialForm: React.FunctionComponent = () => {
  const { t } = useTranslation()
  return (
    <FormStack>
      <FieldStack>
        <FieldStackItem
          name="containerType"
          label={t('field.containerType.label')}
          component={FormikTextField}
        />
        <FieldStackItem
          name="label"
          label={t('field.label.label')}
          required={true}
          component={FormikTextField}
        />
        <FieldStackItem
          name="nettoWeight"
          label={t('field.nettoWeight.label')}
          labelPosition={Position.top}
          component={FormikTextField}
        />
        <FieldStackItem
          name="length"
          label={t('field.length.label')}
          labelPosition={Position.top}
          min={0}
          max={10000}
          component={FormikSpinButton}
        />
        <FieldStackItem
          name="width"
          label={t('field.width.label')}
          labelPosition={Position.top}
          min={0}
          max={10000}
          component={FormikSpinButton}
        />
        <FieldStackItem
          name="height"
          label={t('field.height.label')}
          labelPosition={Position.top}
          min={0}
          max={10000}
          component={FormikSpinButton}
        />
      </FieldStack>
      <FieldStack>
        <Box py={4}>
          <FieldStackItem
            stack={{ grow: 0 }}
            name="inactive"
            render={(fieldProps) => (
              <>
                <Label>{t('field.inactive.label')}</Label>
                <Box py={1}>
                  <FormikCheckbox {...fieldProps} />
                </Box>
              </>
            )}
          />
        </Box>
      </FieldStack>
    </FormStack>
  )
}
